import theme from '@/theme';
import type React from 'react';
import { EnmonLoaderContainer, EnmonText, LogoWrapper, TextWrapper } from './styles';

interface EnmonLoaderProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const EnmonLoader: React.FC<EnmonLoaderProps> = ({ size = 'medium', className }) => {
  const { LogoIcon } = theme;
  return (
    <EnmonLoaderContainer className={className} size={size}>
      <LogoWrapper size={size}>
        <LogoIcon />
      </LogoWrapper>
      <TextWrapper size={size}>
        <EnmonText size={size}>Enmon</EnmonText>
      </TextWrapper>
    </EnmonLoaderContainer>
  );
};
